export default __webpack_public_path__ + "static/media/nft8.760ae323.jpg";